export const endpoint ="https://activerinse.co.za/gymapp";